import { render } from "./sharecodeConfig.vue?vue&type=template&id=5717bd10"
import script from "./sharecodeConfig.vue?vue&type=script&lang=js"
export * from "./sharecodeConfig.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/channel/sharecodeConfig.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5717bd10"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5717bd10', __exports__)) {
    console.log('reload')
    api.reload('5717bd10', __exports__)
  }
  
  module.hot.accept("./sharecodeConfig.vue?vue&type=template&id=5717bd10", () => {
    console.log('re-render')
    api.rerender('5717bd10', render)
  })

}


export default __exports__